module.exports = __webpack_public_path__ + "static/media/github-icon-1.ce89173e.svg";